var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,_vm._b({tag:"component",staticClass:"fw-button",class:[
        _vm.component,
        _vm.sizeClass,
        _vm.colorClass,
        _vm.borderRadiusClass,
        {
            loading: _vm.loading,
            ghost: _vm.ghost,
            active: _vm.active,
            "fw-button--inversed": _vm.inversed,
            "fw-button--padding__zero": _vm.paddingHorizontal,
            "fw-button--padding__right": _vm.paddingOnlyRight,
        },
    ],style:([{
        fontSize: _vm.fontSize,
        color: _vm.fontColor,
        minWidth: _vm.minWidth,
    }, _vm.styles]),attrs:{"tabindex":_vm.ghost ? -1 : 0,"role":"button","aria-disabled":_vm.ghost},on:{"!click":function($event){return _vm.handleClick.apply(null, arguments)}},nativeOn:{"!click":function($event){return _vm.handleClick.apply(null, arguments)}}},'component',_vm.$attrs,false),[(_vm.iconLeft)?_c('FwIcon',{staticClass:"h-mr-15",attrs:{"icon":_vm.iconLeft,"color":_vm.iconColor}}):_vm._e(),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]}),(_vm.iconRight)?_c('FwIcon',{attrs:{"icon":_vm.iconRight}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }